// import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer)
// import { Loading } from 'element- ui'
import draggable from 'vuedraggable';
Vue.use(draggable)

import mammoth from 'mammoth';
Vue.use(mammoth)

// import VueQuillEditor from 'vue-quill-editor';
// Vue.use(VueQuillEditor);

//样式
import '@/assets/style/index.scss'
//svg小图标
import './icons'
import '@/js/permission'
import '@/js/security'
import plug from '@/js/plugin'
Vue.use(plug)
import { cookieHandle } from '@/js/common'

import axios from '@/js/api.js'
import loginjs from '@/store/modules/login.js'
import breadcrumb from '@/store/modules/breadcrumb.js'


// //判断登录状态

let tokenCookie = null,
	loginUserCookieStr = null,
	phone = 0;
tokenCookie = cookieHandle.getCookie(process.env.VUE_APP_BASE_TOKEN)
loginUserCookieStr = cookieHandle.getCookie(process.env.VUE_APP_BASE_USERINFO)
router.beforeEach((to, from, next) => {
	if (tokenCookie != null || loginUserCookieStr != null) {
		if (to.path == '/') {
			phone = JSON.parse(decodeURIComponent(loginUserCookieStr)).phone;
			axios.ajaxGet('get', axios.Api.api.login.GetEnableRoles, { mobile: phone }).then(res => {
				localStorage.setItem('selectRole', JSON.stringify(res.data.Roles));
				if (res.data.Roles.length == 1) {

					axios.ajaxPost('post', axios.Api.api.login.ChangeRole, {
						Answer: "",
						Captcha: "",
						Password: "",
						RoleId: res.data.Roles[0].RoleGuid,
						UserName: phone
					}).then(res => {
						if (res.data.StatusCode == 200) {
							localStorage.removeItem('path');
							localStorage.removeItem('links');
							sessionStorage.removeItem("store");
							let permissions = JSON.parse(res.data.profile.permissions);
							localStorage.setItem('token', res.data.token_type + ' ' + res.data.access_token);
							localStorage.setItem('Version', res.data.profile.version);
							localStorage.setItem('user', JSON.stringify(res.data.profile));
							localStorage.setItem('links', JSON.stringify(permissions));
							loginjs.state.menuFlag = false;
							loginjs.state.openeds.push(permissions.KeyName)
							if (permissions[0].children.length > 0) {
								loginjs.state.permissions = permissions[0].children[0].RoutePath;
								router.push({ path: permissions[0].children[0].RoutePath })
							} else {
								loginjs.state.permissions = permissions[0].RoutePath;
								router.push({ path: permissions[0].RoutePath })
							}
						}
					})
				} else {
					next({ path: '/workbench' });
				}
			});
		} else {
			next();
		}
	} else {
		next();
	}
})


Vue.directive('anchor', {
	inserted: function (el, binding) {
		el.onclick = function () {
			document.documentElement.scrollTop = (document.getElementById('anchor-' + binding.value)).offsetTop
		}
	}
})
// 防抖
Vue.directive('preventReClick', {
	inserted: function (el, binding) {
		document.onkeyup = function (e) {
			if (e.keyCode == 13) {
				changedisabled(el, binding)
			}
		}
		el.addEventListener('click', () => {
			changedisabled(el, binding)
		})
	}
});

function changedisabled(el, binding) {
	if (!el.getAttribute('disabled')) {
		el.setAttribute("disabled", "disabled")
		el.classList.add("is-disabled");
		setTimeout(() => {
			el.classList.remove("is-disabled");
			el.removeAttribute("disabled")
		}, 5000)
	}
}

function getUriParam(key) {
	var variesObj = {},
		kAv = [],
		stringArr = window.location.search.substring(1).split("&");
	for (var i = 0; i < stringArr.length; i++) {
		kAv = stringArr[i].split("=");
		variesObj[kAv[0]] = kAv[1];
	}
	return variesObj[key];
}

Vue.prototype.getUriParam = (key) => {
	var variesObj = {},
		kAv = [],
		stringArr = window.location.search.substring(1).split("&");
	for (var i = 0; i < stringArr.length; i++) {
		kAv = stringArr[i].split("=");
		variesObj[kAv[0]] = kAv[1];
	}
	return variesObj[key];
}

Vue.config.productionTip = false
// Vue.use(ElementUI);

let elementResizeDetectorMaker = require("element-resize-detector");
Vue.prototype.erd = elementResizeDetectorMaker()


Vue.prototype.DebounceBy = (fn, t) => {
	let delay = t || 500
	let timer
	return function () {
		let args = arguments;
		if (timer) {
			clearTimeout(timer)
		}

		let callNow = !timer

		timer = setTimeout(() => {
			timer = null
		}, delay)

		if (callNow) fn.apply(this, args)
	}
}
Vue.prototype.extend = () => {
	var length = arguments.length;
	var target = arguments[0] || {};
	if (typeof target != "object" && typeof target != "function") {
		target = {};
	}
	if (length == 1) {
		target = this;
		i--;
	}
	for (var i = 1; i < length; i++) {
		var source = arguments[i];
		for (var key in source) {
			// 使用for in会遍历数组所有的可枚举属性，包括原型。
			if (Object.prototype.hasOwnProperty.call(source, key)) {
				target[key] = source[key];
			}
		}
	}
	return target;
}


//唯一验证码
Vue.prototype.getCode = function (n, m) {
	let codeStr = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
	let str = '';
	// 验证码有几位就循环几次
	for (var i = 0; i < 4; i++) {
		str += codeStr.charAt(parseInt(Math.random() * 62));
	}
	return str;
}
// uuid
Vue.prototype.uuid = function () {
	let s = [];
	let hexDigits = "0123456789abcdef";
	for (let i = 0; i < 36; i++) {
		s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
	}
	s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
	s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
	s[8] = s[13] = s[18] = s[23] = "-";

	let uuid = s.join("");
	return uuid;
}
// 获取图片转base64
Vue.prototype.getBase64 = function (file) {
	return new Promise(function (resolve, reject) {
		const reader = new FileReader();
		let imgResult = '';
		reader.readAsDataURL(file);
		reader.onload = function () {
			imgResult = reader.result;
		};
		reader.onerror = function (error) {
			reject(error);
		};
		reader.onloadend = function () {
			resolve(imgResult);
		};
	});
};
Vue.prototype.fontSize = function (res) {
	let clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
	if (!clientWidth) return;
	let fontSize = 100 * (clientWidth / 1920);
	return res * fontSize;
};

Vue.prototype.toCanvas = function (id, color, progress) {
	//canvas进度条
	var canvas = document.getElementById(id),
		ctx = canvas.getContext("2d"),
		percent = progress, //最终百分比
		circleX = canvas.width / 2, //中心x坐标
		circleY = canvas.height / this.fontSize(0.02), //中心y坐标
		radius = this.fontSize(0.86), //圆环半径
		// cradius = this.fontSize(0.86), // canvas半径
		lineWidth = this.fontSize(0.09), //圆形线条的宽度
		fontSize = 20; //字体大小

	// //两端圆点
	// function smallcircle1(cx, cy, r) {
	// 	ctx.beginPath();
	// 	ctx.lineWidth = 1;
	// 	ctx.fillStyle = '#06a8f3';
	// 	ctx.arc(cx, cy, r, 0, Math.PI * 2);
	// 	ctx.fill();
	// }

	// function smallcircle2(cx, cy, r) {
	// 	ctx.beginPath();
	// 	ctx.lineWidth = 1;
	// 	ctx.fillStyle = '#fff';
	// 	ctx.arc(cx, cy, r, 0, Math.PI * 2);
	// 	ctx.fill();
	// }
	//画圆
	function circle(cx, cy, r) {
		ctx.beginPath();
		ctx.lineWidth = lineWidth;
		ctx.strokeStyle = '#3D4049';
		ctx.arc(cx, cy, r, Math.PI * 1, Math.PI * 2);
		ctx.stroke();
	}
	//画弧线
	function sector(cx, cy, r, startAngle, endAngle, anti) {
		ctx.beginPath();
		ctx.lineWidth = lineWidth;
		// 渐变色 - 可自定义
		// var linGrad = ctx.createLinearGradient(
		//     circleX-radius-lineWidth, circleY, circleX+radius+lineWidth, circleY
		// );
		// linGrad.addColorStop(0.0, '#06a8f3');
		// linGrad.addColorStop(0.5, '#9bc4eb');
		// linGrad.addColorStop(1.0, '#00f8bb');
		// ctx.strokeStyle = linGrad;
		// 进度条颜色
		ctx.strokeStyle = color;
		//圆弧两端的样式
		ctx.lineCap = 'round';
		//圆弧
		ctx.arc(
			cx, cy, r,
			(Math.PI * 1),
			(Math.PI * 1) + endAngle / 100 * (Math.PI),
			false
		);
		ctx.stroke();
	}
	//刷新
	function loading() {
		if (process >= percent) {
			clearInterval(circleLoading);
		}
		//清除canvas内容
		ctx.clearRect(0, 0, circleX * 2, circleY * 2);
		//中间的字
		ctx.font = fontSize + 'px April';
		ctx.textAlign = 'center';
		ctx.textBaseline = 'middle';
		ctx.fillStyle = '#999';
		// ctx.fillText(parseFloat(process).toFixed(0) + '%', circleX, circleY);
		//圆形
		circle(circleX, circleY, radius);
		//圆弧
		sector(circleX, circleY, radius, Math.PI * 1, process);
		//两端圆点
		// smallcircle1(cradius + Math.cos(2 * Math.PI / 360 * 120) * radius, cradius + Math.sin(2 * Math.PI / 360 * 120) *
		//     radius, 0);
		// smallcircle2(cradius + Math.cos(2 * Math.PI / 360 * (120 + process * 3)) * radius, cradius + Math.sin(2 * Math.PI /
		//     360 * (120 + process * 3)) * radius, 2);
		//控制结束时动画的速度
		if (process / percent > 0.90) {
			process += 0.30;
		} else if (process / percent > 0.80) {
			process += 0.55;
		} else if (process / percent > 0.70) {
			process += 0.75;
		} else {
			process += 1.0;
		}
	}
	var process = 0.0; //进度
	var circleLoading = window.setInterval(function () {
		loading();
	}, 20);
}
String.prototype.colorRgb = function () {
	// 16进制颜色值的正则
	var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
	// 把颜色值变成小写
	var color = this.toLowerCase();
	if (reg.test(color)) {
		// 如果只有三位的值，需变成六位，如：#fff => #ffffff
		if (color.length === 4) {
			var colorNew = "#";
			for (var i = 1; i < 4; i += 1) {
				colorNew += color.slice(i, i + 1).concat(color.slice(i, i + 1));
			}
			color = colorNew;
		}
		// 处理六位的颜色值，转为RGB
		var colorChange = [];
		for (var i = 1; i < 7; i += 2) {
			colorChange.push(parseInt("0x" + color.slice(i, i + 2)));
		}
		return colorChange.join(",");
	} else {
		return color;
	}
};
//判断是否含有某个字符
String.prototype.contain = function (val) {
	if (this.search(val) != -1) {
		return true
	} else {
		return false
	}
}
// 更改对象中某一些属性
Object.defineProperty(Object.prototype, 'changeValue', {
	value: function (b) {
		if (b) {
			let a = Object.keys(b)
			a.forEach(c => {
				this[c] = b[c]
			})
		}
	}
})
new Vue({
	el: '#app',
	router,
	store,
	render: function (h) {
		return h(App)
	}
})
